export default (event, { getProps }) => {
    const { goToNextTask } = getProps();

    event.preventDefault();
    event.stopPropagation();

    goToNextTask && goToNextTask();
};
